// Mirrors the divisions endpoints on core-entity#4697 (not yet merged/deployed)
// and the fixture data seeded in the Capybara Cafe staging org, so this mock
// matches production once the backend ships.
export const mockDivisions = [
  {
    id: '10000000-0000-0000-0000-000000000001',
    name: 'Pay Group A',
    type: 'TYPE_A',
  },
  {
    id: '10000000-0000-0000-0000-000000000002',
    name: 'Pay Group B',
    type: 'TYPE_A',
  },
  {
    id: '10000000-0000-0000-0000-000000000003',
    name: 'Group North',
    type: 'TYPE_B',
  },
  {
    id: '10000000-0000-0000-0000-000000000004',
    name: 'Group South',
    type: 'TYPE_B',
  },
];

// Maps a division id to the ids of employees in mockOrganizationEmployees
// (employeeHandlers.ts) that belong to it. `bulk-mock-employee-N` ids pad
// Pay Group A past 3 members so the "+N more" affordance has something to
// paginate through.
export const mockDivisionEmployeeIds: Record<string, string[]> = {
  '10000000-0000-0000-0000-000000000001': [
    'simple-employee-id',
    'storefront-emp-1',
    ...Array.from({ length: 43 }, (_, i) => `bulk-mock-employee-${i + 1}`),
  ],
  '10000000-0000-0000-0000-000000000002': ['storefront-emp-2'],
  '10000000-0000-0000-0000-000000000003': Array.from(
    { length: 7 },
    (_, i) => `bulk-mock-employee-${i + 44}`
  ),
  '10000000-0000-0000-0000-000000000004': [
    'storefront-emp-1',
    'storefront-emp-2',
  ],
};
